export default {
      id: "wizard-settings-usage",
      viewBox: "0 0 33 34",
      url: __webpack_public_path__ + "img/icons.svg#wizard-settings",
      toString: function () {
        return this.url;
      }
    }